import { hasVideoInput } from '../../tools';
import type { WavespeedModelConfig } from '../types';

export const heygenConfigs: Record<string, WavespeedModelConfig> = {
    // 视频 AI 翻译
    'heygen/video-translate': {
        // https://wavespeed.ai/zh-CN/models/heygen/video-translate
        apiPath: '/heygen/video-translate',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { videoUri, providerOptions } = params;
            return {
                // 视频 URL
                video: videoUri,
                // 可选参数
                output_language: providerOptions?.output_language || 'English',
            };
        },
    },
};